/* global $:false, swal:false */
;(function () {
  'use strict'

  angular
    .module('pub.drop.translation.edit', ['pub.drop.translation.service'])
    .controller('TranslationDropEditCtrl', TranslationDropEditCtrl)

  /** @ngInject */
  function TranslationDropEditCtrl(
    $scope,
    $stateParams,
    $state,
    TranslationDropService,
    UploadService,
  ) {
    var vm = this
    vm.model = {}
    vm.loadT = false
    vm.loadH = false
    vm.loadHWeb = false
    vm.loadL = false
    vm.loadAd = false
    vm.loadVideo = false
    vm.loadAdWeb = false
    vm.pathImgT = ''
    vm.pathImgH = ''
    vm.pathImgHWeb = ''
    vm.pathImgL = ''
    vm.pathImgAd = ''
    vm.pathVideoTrailer = ''
    vm.pathImgAdWeb = ''
    vm.id = parseInt($stateParams.translationId)

    function load() {
      if (vm.id !== 0) {
        TranslationDropService.getTranslation(vm.id).then(function (result) {
          vm.model = result.results
          vm.title = vm.model.t
          vm.description = vm.model.txt
          vm.pathImgT = vm.model['img-t']
          vm.pathImgH = vm.model['img-h']
          vm.pathImgHWeb = vm.model['img-h-web']
          vm.pathImgL = vm.model['img-l']
          vm.pathImgAd = vm.model['img-ad']
          vm.pathVideoTrailer = vm.model['vid-t']
          vm.pathImgAdWeb = vm.model['img-ad-web']
        })
      }
    }

    load()

    vm.save = function () {
      if (!vm.model.t) {
        swal('Title is required', '', 'error')
        return
      }
      if (!vm.model.comm) {
        swal('Locale is required', '', 'error')
        return
      }

      vm.model['id-u'] = 0

      if (vm.model.id) {
        vm.model['id-dr'] = parseInt($stateParams.parentId)
        TranslationDropService.updateTranslation(vm.model.id, vm.model).then(
          function () {
            $state.go('pub.drops.translation', { parentId: vm.model['id-dr'] })
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      } else {
        vm.model['id-dr'] = parseInt($stateParams.parentId)
        TranslationDropService.createTranslation(vm.model['id-dr'], vm.model).then(
          function () {
            $state.go('pub.drops.translation', { parentId: vm.model['id-dr'] })
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      }
    }

    vm.cancel = function () {
      $state.go('pub.drops.translation', { parentId: parseInt($stateParams.parentId) })
    }

    var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadT = false
        return
      }

      if (newVal === null) {
        vm.loadT = false
        return
      }

      vm.loadT = true
      UploadService.save('drops', newVal, 'img-t', $stateParams.id).then(function (fileName) {
        vm.loadT = false
        vm.model['img-t'] = fileName
        vm.pathImgT = fileName
      })
    })

    var watch1 = $scope.$watch('vm.fileImgH', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadH = false
        return
      }

      if (newVal === null) {
        vm.loadH = false
        return
      }

      vm.loadH = true
      UploadService.save('drops', newVal, 'img-h', $stateParams.id).then(function (fileName) {
        vm.loadH = false
        vm.model['img-h'] = fileName
        vm.pathImgH = fileName
      })
    })

    var watch2 = $scope.$watch('vm.fileImgAd', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadAd = false
        return
      }

      if (newVal === null) {
        vm.loadAd = false
        return
      }

      vm.loadAd = true
      UploadService.save('drops', newVal, 'img-ad', $stateParams.id).then(function (fileName) {
        vm.loadAd = false
        vm.model['img-ad'] = fileName
        vm.pathImgAd = fileName
      })
    })

    var watch3 = $scope.$watch('vm.fileImgAdWeb', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadAdWeb = false
        return
      }

      if (newVal === null) {
        vm.loadAdWeb = false
        return
      }

      vm.loadAdWeb = true
      UploadService.save('drops', newVal, 'img-ad-web', $stateParams.id).then(function (fileName) {
        vm.loadAdWeb = false
        vm.model['img-ad-web'] = fileName
        vm.pathImgAdWeb = fileName
      })
    })

    var watch4 = $scope.$watch('vm.fileImgHWeb', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadHWeb = false
        return
      }

      if (newVal === null) {
        vm.loadHWeb = false
        return
      }

      vm.loadHWeb = true
      UploadService.save('drops', newVal, 'img-h-web', $stateParams.id).then(function (fileName) {
        vm.loadHWeb = false
        vm.model['img-h-web'] = fileName
        vm.pathImgHWeb = fileName
      })
    })

    var watch5 = $scope.$watch('vm.fileVideoTrailer', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadTrailer = false
        return
      }

      if (newVal === null) {
        vm.loadTrailer = false
        return
      }

      vm.loadTrailer = true
      UploadService.save('drops', newVal, 'vid-t', $stateParams.id).then(function (fileName) {
        vm.loadTrailer = false
        vm.model['vid-t'] = fileName
        vm.pathVideoTrailer = fileName
        vm.videoTrailer = $sce.trustAsResourceUrl(
          $rootScope.urlS3 + '/drops/' + vm.pathVideoTrailer,
        )
      })
    })

    $scope.$on('$destroy', function () {
      watch()
      watch1()
      watch2()
      watch3()
      watch4()
      watch5()
    })
  }
})()
